import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import styles from './index.css';
import TopRank from './topRank';

class MainContent extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                commentUrl,
                title,
                skey,
                banner01Ad,
                pcUrl,
                showCommentTitle,
                topAd,
                float1Ad,
                float2Ad,
                float3Ad,
                footerAd,
                noAd,
                isHubeiLocal,
            },
        } = this.props;

        const commentConfig = {
            docUrl: commentUrl, // 文章单页的页面地址
            docTitle: title, // 文章的标题
            skey, // 文章评论的skey，这个是在后端生成好后给到前端的
            speUrl: '', // 兼容以后的专题评论
            pcUrl, // 文章pc的页面地址
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 10,
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: true,
            order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
            options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
            recentLimit: 20, // 最近评论数量
            recentReplyLimit: 3, // 最近评论数量显示回复的楼层
            hasIntervalBannerAd: !noAd, // 是否有间隔通栏广告
            intervalBannerAdData: banner01Ad, // 通栏广告数据
            intervalBannerAdStyle: styles.intervalBannerAd, // 通栏广告自定义样式
            usePagination: true, // 是否使用分页
            showEmptyCommentTip: true, // 空评论时是否显示提示
            showTempComment: true, // 即发即显
            // 是否关闭评论和参与数
            isCloseInteract: isHubeiLocal,
        };

        return (
            <div className={styles.mainContent}>
                {!noAd ? <Ad content={topAd} styleName={styles.ad_01} /> : null}
                <div className={styles.commentPage}>
                    <div className={styles.commentLeft}>
                        {showCommentTitle ? (
                            <div className={styles.commentArticleTitle}>
                                <a id="js_title" href={pcUrl} target="_blank">
                                    {title}
                                </a>
                            </div>
                        ) : null}
                        <LazyLoad>
                            <Comment articleInfo={commentConfig} />
                        </LazyLoad>
                    </div>
                    <div className={styles.commentRight}>
                        {!noAd ? <Ad content={float1Ad} styleName={styles.ad_mod_01} /> : null}
                        <TopRank commentUrl={commentUrl} />
                        {!noAd ? <Ad content={float2Ad} styleName={styles.ad_mod_01} /> : null}
                        {!noAd ? <Ad content={float3Ad} styleName={styles.ad_mod_01} /> : null}
                    </div>
                    <div className="clearfix" />
                </div>
                {!noAd ? <Ad content={footerAd} styleName={styles.ad_01} /> : null}
            </div>
        );
    }
}

export default errorBoundary(MainContent);
